import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { v4 as uuidv4 } from 'uuid';

import { BasicObject } from '../models/services.interface';
import { CookieStorageService } from './cookie-storage.service';

// @dynamic
@Injectable({
    providedIn: 'root',
})
export class BtlPrismeService {
    private COOKIE_KEY: string = 'SESSION_PRISME';

    constructor(
        private cookieStorage: CookieStorageService,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this._initialize();
    }

    public getSession(): string {
        return this.cookieStorage.get(this.COOKIE_KEY);
    }

    private _initialize(): void {
        const windowDom: Window = this.document.defaultView.window;
        (windowDom as BasicObject).prisme = this;

        if (!this.getSession()) {
            const expire = new Date();
            expire.setDate(expire.getDate() + 1);
            const guid = uuidv4();
            this.cookieStorage.setItem(this.COOKIE_KEY, guid, expire);
        }
    }
}
